import http from "@/utils/http";

// 注册短信
export function getDomainInfo(data) {
  return http({
    url: "/load/orginfo?domain=" + data,
    method: "GET"
  });
}

// 注册短信
export function userRegisterMsgcode(data) {
  return http({
    url: "/user/msgcode/" + data,
    method: "POST"
  });
}

// 注册
export function userRegister(data, ito) {
  if (ito) {
    return http({
      url: "/user/register",
      method: "POST",
      headers: { ito },
      data
    });
  } else {
    return http({
      url: "/user/register",
      method: "POST",
      data
    });
  }
}

// 登陆
export function userLogin(data, ito) {
  if (ito) {
    return http({
      url: "/user/login",
      method: "POST",
      headers: { ito },
      data
    });
  } else {
    return http({
      url: "/user/login",
      method: "POST",
      data
    });
  }
}

// 获取作品
export function getProject(data) {
  return http({
    url: "/user/free/project/detail?projectid=" + data,
    method: "GET"
  });
}

// 找回密码-获取验证码
export function findPassSMSCode(data) {
  return http({
    url: "/user/findpass/msgcode/" + data,
    method: "POST"
  });
}

// 找回密码
export function findPass(data) {
  return http({
    url: "/user/findpass",
    method: "POST",
    data
  });
}
